import type { ClubRole } from '../../types/api';

interface Props {
  role: ClubRole;
  className?: string;
}

const STYLES: Record<ClubRole, string> = {
  Owner: 'bg-amber-100 dark:bg-amber-900/40 text-amber-800 dark:text-amber-300',
  Admin: 'bg-blue-100 dark:bg-blue-900/40 text-blue-800 dark:text-blue-300',
  Member: 'bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300',
  Guest: 'bg-slate-50 dark:bg-slate-800 text-slate-400 dark:text-slate-500 italic',
};

export function RoleBadge({ role, className = '' }: Props) {
  return (
    <span
      className={`shrink-0 rounded-full px-2.5 py-0.5 text-xs font-semibold ${STYLES[role]} ${className}`}
    >
      {role}
    </span>
  );
}
